module.exports = __webpack_public_path__ + "static/media/5.4cc2a757.gif";